import api from './api';
import { getCommercialCardContext } from '../utils/commercialContext';

const retryIntents = new Map();
let sequence = 0;
export const newCommercialOperationId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  sequence += 1;
  return `ui-${Date.now().toString(36)}-${sequence}-${Math.random().toString(36).slice(2)}`;
};

export const executeCommercialCommand = (type, card, ticketId, payload = {}, options = {}) => {
  const context = options.context || getCommercialCardContext(card, ticketId);
  const key = JSON.stringify([type, context, payload]);
  let intent = retryIntents.get(key);
  if (!intent) {
    const command = JSON.parse(JSON.stringify({
      operationId: options.operationId || newCommercialOperationId(), type, context,
      ...(card ? { expectedRevision: Number(card.revision || 0) } : {}), payload
    }));
    intent = { command, promise: null };
    retryIntents.set(key, intent);
  }
  if (intent.promise) return intent.promise;
  intent.promise = api.post('/deals/commands', intent.command).then(({ data }) => {
    retryIntents.delete(key);
    if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('commercial:changed', { detail: { ticketId: context.ticketId, ...data } }));
    return data;
  }).catch(error => {
    intent.promise = null;
    // A rejected precondition is a completed failure; a transport timeout keeps its original intent.
    if (error.response && error.response.status < 500 && !['ERR_COMMAND_IN_PROGRESS', 'ERR_COMMAND_OUTCOME_UNKNOWN'].includes(error.response.data?.error)) retryIntents.delete(key);
    throw error;
  });
  return intent.promise;
};
